import Service from '@/core/services/service';
import { ServicePromise } from '@/core/services/interfaces';
import api from './config';

export default {
    logout(): ServicePromise<any> {
        const services = new Service(api);
        const url = 'account/logout';

        return services.postData(url);
    },

    otp(token: string): ServicePromise<any> {
        const services = new Service(api);
        const url = 'account/onetimepassword';
        const data = {
            token
        };

        return services.postData(url, data);
    }
};
